import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import InstagramIcon from '@mui/icons-material/Instagram';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const Metrics = () => {
  const theme = useTheme();

  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) return;
    setViewPortEntered(isVisible);
  };

  const getIcon = (iconName) => {
    const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };
    switch (iconName) {
      case 'LanguageIcon':
        return <LanguageIcon {...iconProps} />;
      case 'InstagramIcon':
        return <InstagramIcon {...iconProps} />;
      case 'PlayCircleOutlineIcon':
        return <PlayCircleOutlineIcon {...iconProps} />;
      default:
        return <LanguageIcon {...iconProps} />;
    }
  };

  const metricsData = [
    {
      title: 90,
      label: 'Seguidores TNO Network',
      subtitle: 'Twitter, Facebook, Instagram.',
      suffix: 'K+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 850,
      label: 'Seguidores Santiago Gutiérrez',
      subtitle: 'Instagram, TikTok.',
      suffix: 'K+',
      icon: getIcon('InstagramIcon'),
    },
    {
      title: 85,
      label: 'Seguidores Angélica Lugo',
      subtitle: 'Instagram, X, TikTok.',
      suffix: 'K+',
      icon: getIcon('InstagramIcon'),
    },
    {
      title: 30000,
      label: 'Visitas mensuales del ecosistema TNO',
      subtitle: 'Plataforma web y editorial (ads TNO).',
      suffix: '+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 230,
      label: 'Reproducciones mensuales en Instagram',
      subtitle: 'Clips y reels de formato investigación.',
      suffix: 'K',
      icon: getIcon('PlayCircleOutlineIcon'),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Métricas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Los números de Expedientes del Delito
        </Box>
        <Typography
          variant="body1"
          align="center"
          color="textSecondary"
          sx={{ mb: 4, maxWidth: 700, mx: 'auto' }}
        >
          Danimar se integra a una audiencia madura y exigente que responde a mensajes claros,
          verificados y de alta autoridad editorial.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {metricsData.map((item, i) => (
          <Grid key={i} item xs={12} sm={6} md={2.4}>
            <Box display="flex" justifyContent="center" alignItems="center" marginBottom={2}>
              {item.icon}
            </Box>
            <Typography variant="h4" align="center" gutterBottom>
              <Box component="span" fontWeight={700}>
                <VisibilitySensor
                  onChange={(isVisible) => setViewPortVisibility(isVisible)}
                  delayedCall
                >
                  <CountUp
                    redraw={false}
                    end={viewPortEntered ? item.title : 0}
                    start={0}
                    suffix={item.suffix}
                  />
                </VisibilitySensor>
              </Box>
            </Typography>
            <Typography align="center" variant="subtitle1" fontWeight={600} gutterBottom>
              {item.label}
            </Typography>
            <Typography color="textSecondary" align="center" variant="body2" component="p">
              {item.subtitle}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Metrics;

